"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockKermanRewardsFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var MockKermanRewardsFactory = /** @class */ (function (_super) {
    __extends(MockKermanRewardsFactory, _super);
    function MockKermanRewardsFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    MockKermanRewardsFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    MockKermanRewardsFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    MockKermanRewardsFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    MockKermanRewardsFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    MockKermanRewardsFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return MockKermanRewardsFactory;
}(contracts_1.ContractFactory));
exports.MockKermanRewardsFactory = MockKermanRewardsFactory;
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "Burnt",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "Claimed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_sablierContract",
                type: "address",
            },
        ],
        name: "SablierContractSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "_streamId",
                type: "uint256",
            },
        ],
        name: "SablierStreamIdSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "stakeDeadline",
                type: "uint256",
            },
        ],
        name: "StakeDeadlineSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "Staked",
        type: "event",
    },
    {
        inputs: [],
        name: "claim",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "claimStreamFunds",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "claimed",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "currentTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_sablierContract",
                type: "address",
            },
            {
                internalType: "address",
                name: "_stakingToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "_rewardsToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_stakeDeadline",
                type: "uint256",
            },
        ],
        name: "init",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_user",
                type: "address",
            },
        ],
        name: "rewardsAvailable",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "rewardsToken",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "sablierContract",
        outputs: [
            {
                internalType: "contract ISablier",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "sablierRatePerSecond",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "sablierStartTime",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "sablierStopTime",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "sablierStreamId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_timestamp",
                type: "uint256",
            },
        ],
        name: "setCurrentTimestamp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_sablierContract",
                type: "address",
            },
        ],
        name: "setSablierContract",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_sablierStreamId",
                type: "uint256",
            },
        ],
        name: "setSablierStreamId",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_stakeDeadline",
                type: "uint256",
            },
        ],
        name: "setStakeDeadline",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "stake",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "stakeDeadline",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "staked",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "stakingToken",
        outputs: [
            {
                internalType: "contract IKermanERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalStaked",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "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";
